import {studentEndpoints} from "../apis"
import {apiConnector} from "../apiconnector";
import {setPaymentLoading} from "../../slices/courseSlice"
import {resetCart} from "../../slices/cartSlice";
import toast from "react-hot-toast";
import rzpLogo from "../../assets/Logo/rzp_logo.png"

const {
        COURSE_PAYMENT_API,
        COURSE_VERIFY_API,
        SEND_PAYMENT_SUCCESS_EMAIL_API 
      } = studentEndpoints;

function loadScript(src)
{
    return new Promise((resolve)=>{
        const script = document.createElement("script");
        script.src = src;

        script.onload = () =>{
            resolve(true);
        }
        script.onerror = () =>{
            resolve(false);
        }
        document.body.appendChild(script);
    })
}

export async function buyCourse (token,courses,userDetails,navigate,dispatch)
{
    const toastId = toast.loading("Loading");

    try
    {
        // load the script
        const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

        if(!res)
        {
            toast.error("Razorpay SDK is not responding");
            return;
        }

        // initiate the order
        const orderResponse = await apiConnector("POST",COURSE_PAYMENT_API,{
            courses
        },{Authorization: `Bearer ${token}`})
        console.log("Response: ",orderResponse);

        if(!orderResponse.data.success)
        {
            throw new Error(orderResponse.data.message);
        }
        console.log("Printing orderResponse: ",orderResponse);
        // options
        const options = {
            // key: process.env.RAZORPAY_KEY,
            key: "rzp_test_RpQ2ZokppZS55d",
            currency: orderResponse.data.message.currency,
            amount: `${orderResponse.data.message.amount}`,
            order_id: orderResponse.data.message.id,
            name: "Study Notion",
            description: "Thank you for purchasing the course",
            image: rzpLogo,
            prefill: {
                name: `${userDetails.firstName}`,
                email: userDetails.email,
            },
            handler: async function(response)
            {
                // send successful mail
                sendPaymentSuccessEmail(response,orderResponse.data.message.amount,token);
                // verify payment
                verifyPayment({...response,courses},token,navigate,dispatch);
            }
        }
        console.log("Options: ",options)
        // miss
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
        paymentObject.on("payment.failed",function(response)
        {
            console.log("Response: ",response);
            toast.error("Error while making payment");
            console.log(response.error);
        })
    }
    catch(e)
    {
        console.log("Error in payment api: ",e);
        toast.error("Could not make payment");
    }
    toast.dismiss(toastId);
}

async function sendPaymentSuccessEmail(response,amount,token)
{
    try
    {
        await apiConnector("POST",SEND_PAYMENT_SUCCESS_EMAIL_API,{
            orderId: response.razorpay_order_id,
            paymentId: response.razorpay_payment_id,
            amount,
        },{
            Authorization: `Bearer ${token}`
        })
    }
    catch(e)
    {
        console.log("Payment success email error: ",e);
    }
}

async function verifyPayment(bodyData,token,navigate,dispatch)
{
    const toastId = toast.loading("Verifying payment");
    dispatch(setPaymentLoading(true));
    try
    {
        const response = await apiConnector("POST",COURSE_VERIFY_API,bodyData,{
            Authorization: `Bearer ${token}`,
        });
        if(!response.data.success)
        {
            throw new Error(response.data.message);
        }
        toast.success("Payment successful, course has been added");
        navigate("/dashboard/enrolled-courses");
        dispatch(resetCart());
    }
    catch(e)
    {
        console.log("Payment verify error: ",e);
        toast.error("Could not verify payment");
    }

    toast.dismiss(toastId);
    dispatch(setPaymentLoading(false));
}